/** Free-tier daily like cap (UTC day), enforced server-side in add_like. */
export const FREE_DAILY_LIKE_LIMIT = 15;

export function isLikeLimitError(error) {
  if (!error) return false;
  const message = String(error.message || error.details || error.hint || "");
  const code = String(error.code || error?.error?.code || "");
  return (
    message.includes("like_limit_reached") ||
    error.likeLimitReached === true ||
    (code === "P0001" && message.toLowerCase().includes("like"))
  );
}

export function createLikeLimitError(cause) {
  const err = new Error("like_limit_reached");
  err.likeLimitReached = true;
  err.cause = cause;
  return err;
}
